<template>
  <div class="ship-order-itinerary-location">
    <div v-if="estimatedArrival" class="row">
      <i aria-hidden="true" class="pi pi-clock" />
      {{ t('orders.estimatedArrival', { date: d(estimatedArrival, 'short') }) }}
    </div>

    <div class="row">
      <i aria-hidden="true" class="pi pi-map-marker" />
      <NamedAddress
        :name="location?.locationName"
        :address="location?.toAddress()"
        suppress-country
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { EmbeddableLocation } from '@/model';

import NamedAddress from '@rygen/rygen-ui/components/address/NamedAddress.vue';

const props = defineProps({
  location: {
    type: EmbeddableLocation,
    default: () => new EmbeddableLocation(),
  },
  estimatedArrival: {
    type: Date,
    default: () => undefined,
  },
});
const { location, estimatedArrival } = toRefs(props);

const { d, t } = useI18n();
</script>

<style>
.ship-order-itinerary-location {
  display: flex;
  gap: var(--gap-1);
  flex-direction: column;

  .row {
    display: flex;
    gap: var(--gap-1);
  }

  .named-address {
    max-width: 200px;

    .named-address__name {
      color: var(--p-gray-600);
    }

    .named-address__address-line,
    .named-address__zone-information {
      color: var(--p-gray-400);
    }
  }
}
</style>
